const analyticsTypes = {
  SAVINGS_VIEW: 'year_in_review_View',
};

const analyticsActions = [{
  type: analyticsTypes.SAVINGS_VIEW
}];

export {
  analyticsTypes,
  analyticsActions
};
